/** GB Wave 站点常量（域名、APK 信息） */
export const SITE_ORIGIN = 'https://gb-wave.com';
export const SITE_NAME = 'GB Wave';

/** 与 Hero 设计稿一致的主品牌绿 */
export const BRAND_GREEN = '#28A745';
export const BRAND_GREEN_DARK = '#218838';
export const BRAND_GREEN_LIGHT = '#EAF7EE';
export const BRAND_GREEN_RGB = '40, 167, 69';

export const APK_VERSION = '18.80';
export const APK_SIZE = '95 MB';
export const APK_UPDATED = 'Oct 2026';
export const APK_ANDROID = '5.0+';
export const APK_DOWNLOAD_URL =
  process.env.VUE_APP_GBLINK ||
  process.env.VUE_APP_DEFAULT_APK ||
  'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.928_gw.apk';

export const APK_INFO_ROWS = [
  { label: 'Latest Version', value: `v${APK_VERSION}` },
  { label: 'Updated', value: APK_UPDATED },
  { label: 'APK Size', value: APK_SIZE },
  { label: 'Android', value: APK_ANDROID },
  { label: 'Category', value: 'Communication' },
  { label: 'Developer', value: 'GBMods' },
  { label: 'License', value: 'Free' },
  { label: 'File Format', value: 'APK' },
  { label: 'Downloads', value: '8M+' },
  { label: 'Last Verified', value: APK_UPDATED },
];

/** 生成 canonical link 数组，供路由 meta 使用 */
export function canonicalLink(path) {
  const href = path.startsWith('http') ? path : `${SITE_ORIGIN}${path}`;
  return [{ rel: 'canonical', href }];
}
